export default __webpack_public_path__ + "static/media/b2.e931aa12.jpg";